import type {
  Step,
  CallBackProps,
  STATUS,
  EVENTS,
  ACTIONS,
} from 'react-joyride';

export type TourName = 'dashboard' | 'revisions' | 'draftEditor';

export interface TourStep extends Step {
  target: string;
  content: string;
  title?: string;
  disableBeacon?: boolean;
  spotlightClicks?: boolean;
  placement?:
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'center'
    | 'auto';
}

export interface TourConfig {
  name: TourName;
  steps: TourStep[];
  autoStart?: boolean;
}

export interface TourState {
  activeTour: TourName | null;
  stepIndex: number;
  isRunning: boolean;
  completedTours: TourName[];
}

export interface TourContextValue {
  state: TourState;
  startTour: (tourName: TourName) => void;
  endTour: () => void;
  nextStep: () => void;
  prevStep: () => void;
  goToStep: (index: number) => void;
  resetTour: (tourName: TourName) => void;
  isTourCompleted: (tourName: TourName) => boolean;
  markTourCompleted: (tourName: TourName) => void;
}

export interface TourCallbackData extends CallBackProps {
  status: (typeof STATUS)[keyof typeof STATUS];
  type: (typeof EVENTS)[keyof typeof EVENTS];
  action: (typeof ACTIONS)[keyof typeof ACTIONS];
}

export const TOUR_STORAGE_KEY = 'magpiie_tours_completed';
